import createAxios from '/@/utils/axiosNode'
export const indexUrl = '/api/user'

// 刷新用户次数
export function refreshUserWord() {
  return createAxios({
    url: indexUrl + '/wordCount',
    method: 'GET',
  })
}

// 获取用户次数消耗记录
export function WordCountLog(query: anyObj) {
  return createAxios({
    url: indexUrl + '/wordCountLog',
    method: 'GET',
    params: query
  })
}


// 获取用户所有订单
export function getAllOrder(params: anyObj = {}) {
  const { page = 1, pageSize = 30, buy_type = '' } = params
  return createAxios(
    {
      url: `${indexUrl}/order?page=${page}&pageSize=${pageSize}&buy_type=${buy_type}`,
      method: 'GET'
    }
  )
}